import React from 'react';
import Header from '../components/Header';
import './Home.css';

function Home() {
  return (
    <>
      <Header />

      <main className="home-page">
        <section className="intro-section">
          <div className="intro-container">
            <p className="section-label">About EruBright</p>
            <h2 className="section-title">
              Battery research and development with a focused, innovation-led approach
            </h2>
            <p className="section-text">
              EruBright is a battery R&amp;D company focused on the development of
              new technologies, materials concepts, and cell design approaches.
              The company is being built to support early-stage innovation,
              technical exploration, and future collaboration in advanced battery
              development.
            </p>
          </div>
        </section>

        <section className="focus-section">
          <div className="focus-container">
            <div className="focus-card">
              <h3>Materials Innovation</h3>
              <p>
                Exploring new concepts and development routes for battery
                materials and performance improvement.
              </p>
            </div>

            <div className="focus-card">
              <h3>Cell Design</h3>
              <p>
                Investigating design strategies, structures, and technical
                approaches for next-generation cell development.
              </p>
            </div>

            <div className="focus-card">
              <h3>R&amp;D Collaboration</h3>
              <p>
                Building towards collaboration with partners interested in
                battery technology development, validation, and innovation.
              </p>
            </div>
          </div>
        </section>

        <section className="cta-section">
          <div className="cta-container">
            <h2>Interested in discussing a technical idea or collaboration?</h2>
            <p>
              EruBright welcomes enquiries related to battery innovation,
              development opportunities, and future partnerships.
            </p>
            <a href="/contact" className="cta-button">
              Get in touch
            </a>
          </div>
        </section>
      </main>
    </>
  );
}

export default Home;